<template>
  <div class="flex items-center justify-center rounded- w-7 h-7 bg-primaryDark text-primaryLight text-[13px]">
    <span class="avatar-initials">{{ initials }}</span>
  </div>
</template>

  
  <script>
  export default {
    name: "UserAvatar",
    props: {
      fullName: {
        type: String,
        required: true,
      },
    },
    computed: {
      initials() {
        if (!this.fullName) return '';
        const nameParts = this.fullName.trim().split(' ');
        const firstInitial = nameParts[0]?.charAt(0)?.toUpperCase() || '';
        const lastInitial = nameParts[1]?.charAt(0)?.toUpperCase() || '';
        return `${firstInitial}${lastInitial}`;
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  